import { post, get, baseURL } from "@/utils/request";

export const getMyData = (params: any) => post(`/agent/commission/myData`, params);

export const getRewardList = (params: any) => post(`/agent/commission/rewardList`, params);

export const getRewardDetail = (params: any) => post(`/agent/commission/rewardDetail`, params);